module.exports = __webpack_public_path__ + "img/icn_brand12.88a897d2.svg";